'use es6';

import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import { oneOfObjectValues } from 'feedback-utils/propTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { NavMarker } from 'react-rhumb';
import UIButton from 'UIComponents/button/UIButton';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { Popover } from 'foundations-components/transitional/components/Popover';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import * as Modes from '../../constants/modes';
import { EMPTY_STRING, Selectors } from '../../Constants';
import PreviewRibbon from '../PreviewRibbon';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const INPUT_CHAR_LIMIT = 1500;
class FollowUp extends Component {
  constructor(props) {
    super(props);
    this.dismissPopover = () => {
      console.warn('dismissing this popover because of reasons');
      this.setState({
        popoverOpen: false
      });
    };
    this.state = {
      followUpInputValue: EMPTY_STRING,
      popoverOpen: true
    };
  }
  handleFollowUpChange({
    target: {
      value
    }
  }) {
    this.setState({
      followUpInputValue: value
    });
  }
  isButtonDisabled() {
    const {
      submitButtonDisabled
    } = this.props;
    const {
      followUpInputValue
    } = this.state;
    return submitButtonDisabled || followUpInputValue.length > INPUT_CHAR_LIMIT;
  }
  render() {
    const {
      autoFocus,
      mode,
      onSubmitClick,
      respondentType,
      config: {
        followUpQuestions: {
          [respondentType.toLowerCase()]: question
        },
        submitLabel
      }
    } = this.props;
    const {
      followUpInputValue,
      popoverOpen
    } = this.state;
    const isLivePreview = mode === Modes.LIVE_PREVIEW;
    return /*#__PURE__*/_jsxs("div", {
      className: "follow-up-page",
      children: [/*#__PURE__*/_jsx("div", {
        className: "heading",
        "data-selenium-test": Selectors.FOLLOW_UP.TEXT,
        children: question
      }), /*#__PURE__*/_jsxs(View, {
        paddingInline: "500",
        paddingBlockStart: isLivePreview ? '900' : '300',
        children: [isLivePreview && /*#__PURE__*/_jsx(PreviewRibbon, {}), /*#__PURE__*/_jsx(UICharacterCounter, {
          id: "input",
          counter: "down",
          max: INPUT_CHAR_LIMIT,
          renderInput: ({
            count,
            value,
            onChange
          }) => /*#__PURE__*/_jsx(NavMarker, {
            name: "follow_up",
            children: /*#__PURE__*/_jsx(TextArea, {
              defaultFocused: autoFocus,
              "data-selenium-test": Selectors.FOLLOW_UP.INPUT,
              error: count < 0,
              onChange: (...args) => {
                onChange(...args);
                this.handleFollowUpChange(...args);
              },
              resize: false,
              rows: 5,
              value: value
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Popover, {
        content: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsxs(UIPopoverHeader, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "testHeader"
            }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
              popoverUse: "longform",
              onClick: this.dismissPopover
            })]
          }), /*#__PURE__*/_jsx(UIPopoverBody, {
            children: /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "testBody"
              })
            })
          })]
        }),
        open: isLivePreview && popoverOpen,
        constrainTarget: true,
        placement: "right top",
        menuInlineSize: "250px",
        use: "longform",
        children: /*#__PURE__*/_jsx(UIButton, {
          id: "button",
          "data-selenium-test": Selectors.SUBMIT_BUTTON,
          disabled: this.isButtonDisabled(),
          onClick: () => onSubmitClick(followUpInputValue),
          responsive: false,
          size: "small",
          use: "primary",
          children: submitLabel
        })
      })]
    });
  }
}
FollowUp.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  config: PropTypes.instanceOf(Record).isRequired,
  mode: oneOfObjectValues(Modes),
  onSubmitClick: PropTypes.func.isRequired,
  respondentType: oneOfObjectValues(RespondentTypes).isRequired,
  submitButtonDisabled: PropTypes.bool.isRequired
};
export default FollowUp;